module.exports = __webpack_public_path__ + "static/media/badge_level_5_2.bb823ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_level_5_2.png
// module id = 504
// module chunks = 0